// components/AdministrativeActionsModal/AdministrativeTabs/NotificationTab.jsx
import {
  Skeleton,
  TextField,
  Select,
  MenuItem
} from "@mui/material"
import {
  FilterOption
} from "../../../components"
import AutoCompleteSearch from "../AutoCompleteSearch"
import {
  WhoActionContainer,
  FilterOptionsContainer,
  NotificationContainer,
  SeverityLevelContainer,
  TextCount
} from "./styled"
import { useTranslation } from "react-i18next"

const NotificationTab = ({
  userList,
  users,
  loading,
  selectUser,
  removeUserFromList,
  text,
  setText,
  severity,
  setSeverity,
  SEVERITY
}) => {
  const onType = e => setSeverity(e.target.value)
  const { t } = useTranslation('common')

  return (
    <>
      <WhoActionContainer>
        <span>{t('admin_actions_modal.user_select')}</span>
        <AutoCompleteSearch options={userList} onSelect={selectUser} />
        <FilterOptionsContainer>
          {loading ? (
            <>
              <Skeleton>
                <FilterOption isSelected dismissable name="Jakob Carder" />
              </Skeleton>
              <Skeleton>
                <FilterOption isSelected dismissable name="Jakob Carder" />
              </Skeleton>
            </>
          ) : (
            users?.map(({ id, name }) => (
              <FilterOption
                key={id}
                isSelected
                dismissable
                name={name}
                onClick={() => removeUserFromList({ id })}
              />
            ))
          )}
        </FilterOptionsContainer>
      </WhoActionContainer>

      <NotificationContainer>
        <span>{t('admin_actions_modal.notification')}</span>
        <TextField
          id="outlined-multiline-static"
          multiline
          rows={3}
          placeholder={t('admin_actions_modal.user_select_placeholder')}
          onChange={e => setText(e?.target?.value)}
          value={text}
          error={text?.length > 160}
        />
        <TextCount length={text?.length}>
          {text?.length || 0} {t('admin_actions_modal.text_count')}
        </TextCount>
      </NotificationContainer>

      <SeverityLevelContainer>
        <span>{t('admin_actions_modal.severity_level_header')}</span>
        <Select
          labelId="severity-level-label"
          id="severity-level"
          value={severity}
          onChange={onType}
        >
          <MenuItem value={SEVERITY.LOW}>{t('admin_actions_modal.low')}</MenuItem>
          <MenuItem value={SEVERITY.MEDIUM}>{t('admin_actions_modal.medium')}</MenuItem>
          <MenuItem value={SEVERITY.HIGH}>{t('admin_actions_modal.high')}</MenuItem>
        </Select>
      </SeverityLevelContainer>
    </>
  )
}

export default NotificationTab
